export const brandFunnelEndPoint = `brand-funnel`;
